<div class="hole-pos-tables" *ngIf="hasPinsheet">
    <div class="vertical-pos-table">
        <table>
            <thead [ngStyle]="{'height': greenList.length ? 'calc(100%/{{greenList.length + 2}})' : 'auto'}">
                <th style="text-align: right;">
                    LEFT
                </th>
                <th style="text-align: center;">
                    |
                </th>
                <th style="text-align: left;">
                    RIGHT
                </th>
            </thead>
            <tbody>
                <tr *ngFor="let green of greenList"
                    [ngStyle]="{'height': greenList.length ? 'calc(100%/{{greenList.length + 2}})' : 'auto'}">
                    <td>
                        <div *ngIf="green.PositionY.includes('L')" style="float: right;" class="red-circle">
                        </div>
                    </td>
                    <td>
                        {{green.Name}}
                    </td>
                    <td>
                        <div *ngIf="green.PositionY.includes('R')" style="float: left;" class="red-circle">
                        </div>
                    </td>
                </tr>
                <tr class="total lr-color">
                    <td style="text-align: right;">
                        {{leftHolesCount}}
                    </td>
                    <td>
                        |
                    </td>
                    <td style="text-align: left;">
                        {{rightHolesCount}}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="horizontal-pos-table">
        <table>
            <thead [ngStyle]="{'height': greenList.length ? 'calc(100%/{{greenList.length + 2}})' : 'auto'}">
                <th style="text-align: right;">
                    F  &nbsp; |
                </th>
                <th style="text-align: center;">
                    M
                </th>
                <th style="text-align: left;">
                    |  &nbsp; B
                </th>
            </thead>
            <tbody>
                <tr *ngFor="let green of greenList"
                    [ngStyle]="{'height': greenList.length ? 'calc(100%/{{greenList.length + 2}})' : 'auto'}">
                    <td>
                        <div class="color-container left-container">
                            <div [ngClass]="{'fmb-color': green.PositionX && +green.PositionX <= +green.Depth/3}">
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="color-container center-container">
                            <div [ngClass]="{'fmb-color': green.PositionX && +green.PositionX > +green.Depth/3 && +green.PositionX <=  (+green.Depth/3)*2}">   
                                {{green.Name}}                         
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="color-container right-container">
                            <div [ngClass]="{'fmb-color': green.PositionX && +green.PositionX > (+green.Depth/3)*2 && +green.PositionX <=  +green.Depth}">
                            </div>
                        </div>
                    </td>
                    <!-- <td [ngClass]="{'fmb-color': green.PositionX && +green.PositionX <= +green.Depth/3}">
                    </td>
                    <td [ngClass]="{'fmb-color': green.PositionX && +green.PositionX > +green.Depth/3 && +green.PositionX <=  (+green.Depth/3)*2}">
                        {{green.Name}}
                    </td>
                    <td [ngClass]="{'fmb-color': green.PositionX && +green.PositionX > (+green.Depth/3)*2 && +green.PositionX <=  +green.Depth}">
                    </td> -->
                </tr>
                <tr class="total fmb-color">
                    <td style="text-align: right;">
                        {{frontHolesCount}} &nbsp; |
                    </td>
                    <td>
                        {{middleHolesCount}}
                    </td>
                    <td style="text-align: left;">
                        | &nbsp; {{backHolesCount}}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
